import { MotionPlayer } from '@af/design-system-docs-ui/motion-player';
import choreographyDark from "../../../../src/pages/rovo-ui/motion/_assets/_videos/choreography-dark.mp4";
import choreographyLight from "../../../../src/pages/rovo-ui/motion/_assets/_videos/choreography-light.mp4";
import generativeBorderDark from "../../../../src/pages/rovo-ui/motion/_assets/_videos/generative-border-dark.mp4";
import generativeBorderLight from "../../../../src/pages/rovo-ui/motion/_assets/_videos/generative-border-light.mp4";
import impliedMotionDark from "../../../../src/pages/rovo-ui/motion/_assets/_videos/implied-motion-dark.mp4";
import impliedMotionFabDark from "../../../../src/pages/rovo-ui/motion/_assets/_videos/implied-motion-fab-dark.mp4";
import impliedMotionFabLight from "../../../../src/pages/rovo-ui/motion/_assets/_videos/implied-motion-fab-light.mp4";
import impliedMotionLight from "../../../../src/pages/rovo-ui/motion/_assets/_videos/implied-motion-light.mp4";
import omnibarConceptDark from "../../../../src/pages/rovo-ui/motion/_assets/_videos/omnibar-concept-dark.mp4";
import omnibarConceptLight from "../../../../src/pages/rovo-ui/motion/_assets/_videos/omnibar-concept-light.mp4";
import spotIlloMorphDark from "../../../../src/pages/rovo-ui/motion/_assets/_videos/spot-illo-morph-dark.mp4";
import spotIlloMorphLight from "../../../../src/pages/rovo-ui/motion/_assets/_videos/spot-illo-morph-light.mp4";
import toolbarDark from "../../../../src/pages/rovo-ui/motion/_assets/_videos/toolbar-dark.mp4";
import toolbarLight from "../../../../src/pages/rovo-ui/motion/_assets/_videos/toolbar-light.mp4";
import * as React from 'react';
export default {
  MotionPlayer,
  choreographyDark,
  choreographyLight,
  generativeBorderDark,
  generativeBorderLight,
  impliedMotionDark,
  impliedMotionFabDark,
  impliedMotionFabLight,
  impliedMotionLight,
  omnibarConceptDark,
  omnibarConceptLight,
  spotIlloMorphDark,
  spotIlloMorphLight,
  toolbarDark,
  toolbarLight,
  React
};